import React  from 'react';
import { renderToStaticMarkup } from 'react-dom/server'
import classNames from 'classnames'
import { Spacer, Truncate } from '@cleartrip/bento/lib';
import download from 'downloadjs'

const Container = props => (
	<div   
        title={props.title}
		className="bs-border bg-neutral-0 br-4 flex-inline flex-column flex-center m-2 px-2 py-3 c-pointer hover:elevation-5"
		onClick={props.onClick}
        style={{width: 'calc(20% - 16px)'}}
        download
	>
		{props.children}
	</div>
);

const Wrapper = props => (
	<div className="flex-inline flex-column flex-middle"
	>
		{props.children}
	</div>
);

function IconItem(props) {
	const { label, IconComponent, className } = props;
	const component = label
    const attrs = {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": 36,
        "height": 36,
        "color": "#999999"
      }
	return (
        <Container
            title={`Click to download <${label} />`}
            onClick={() => {
                navigator.clipboard.writeText(component).then(() => {
                    window.alert(`Copied '${label}' to Clipboard. Press Ok to download`);
                });
                download(
                    renderToStaticMarkup(<IconComponent {...attrs} />),
                    `${label}.svg`,
                    'image/svg+xml',
                  )
            }}
        >
            <Wrapper>
                <IconComponent className={classNames("br-4 nmx-1 nmy-1 py-1 px-1", className)} height={40} width={40} />
                <Spacer className="pt-2" />
                <Truncate as="span" className="c-neutral-700 fs-2 w-100p ta-center">{label}</Truncate>
            </Wrapper>
        </Container>
    );
}

export default IconItem;
